import { render, staticRenderFns } from "./RentalObjectTakeoverProtocols.vue?vue&type=template&id=dbf563fa&scoped=true&"
import script from "./RentalObjectTakeoverProtocols.vue?vue&type=script&lang=js&"
export * from "./RentalObjectTakeoverProtocols.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectTakeoverProtocols.vue?vue&type=style&index=0&id=dbf563fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf563fa",
  null
  
)

export default component.exports